import {useCart} from '@shopify/hydrogen';
import clsx from 'clsx';
import {useCartStore} from '../../hooks/useCartStore';
import translate from '../../utils/getTranslation';

type Props = {
  onClick?: () => void;
  className?: string;
};

/**
 * A client component that defines the behavior when a user toggles a cart
 */
export default function CartToggle({onClick, className}: Props) {
  const {totalQuantity} = useCart();
  const {isOpen, toggleOpen} = useCartStore();

  return (
    <div className="group">
      <button
        aria-expanded={isOpen}
        aria-controls={translate('CART')}
        onClick={() => {
          toggleOpen();
          onClick?.();
        }}
        className={clsx('flex items-center gap-2', className)}
      >
        <p className="duration-200 group-hover:bg-opacity-70">
          {translate('CART')} <span>({totalQuantity})</span>
        </p>
      </button>
    </div>
  );
}
